import { Injectable } from '@angular/core';
import { BaseService } from 'cre-ng';

import { ApiZipCode } from '@app/shared/shared.model';

@Injectable()
export class GeoLocationService extends BaseService {
  getEndPoint(): string {
    return '/geolocation/api/v1';
  }

  zipCodeInfo(zipCode: string) {
    return this.httpClient
      .get<ApiZipCode>(this.serviceUrl + `/zipcode/info?code=${zipCode}`)
      .toPromise();
  }
}
